{
  "resume_prompt": {
    "title": "Grabación pausada",
    "reason_call": "Tu reunión se pausó por una llamada entrante.",
    "reason_headset": "Tus auriculares se desconectaron, pausamos la grabación para evitar captar audio inesperado.",
    "reason_other": "Tu reunión se pausó por una interrupción del sistema.",
    "discard": "Descartar",
    "resume": "Reanudar"
  },
  "recorder": {
    "default_title": "Reunión del {date}",
    "title": "Nueva grabación",
    "subtitle": "Graba tu reunión y la IA extraerá las tareas accionables.",
    "field_title": "Título",
    "destination": "Destino",
    "personal": "Personal",
    "choose_project": "Elegir proyecto…",
    "attendees": "Asistentes ({selected}/{total})",
    "select_all": "Todos",
    "only_me": "Solo yo",
    "monthly_quota": "Cuota mensual",
    "max_per_meeting": "Hasta {n} min por reunión",
    "max_per_meeting_unlimited": "Sin límite por reunión",
    "save_audio": "Guardar audio",
    "start_recording": "Iniciar grabación",
    "of_max": "de máx. {time}",
    "silence_warning": "¿Estás hablando? No estamos captando audio.",
    "pause": "Pausar",
    "resume": "Reanudar",
    "stop_process": "Detener y procesar",
    "cancel_discard": "Cancelar y descartar",
    "uploading": "Subiendo audio…",
    "oem_warning": "En tu {device} recomendamos mantener Tworks abierto durante la grabación. Si bloqueas la pantalla puede interrumpirse. ¿Continuar de todos modos?",
    "unsupported_browser": "Tu navegador no soporta grabación de audio.",
    "mic_denied_mobile": "No se pudo acceder al micrófono. Permite el acceso desde Ajustes → Apps → Tworks → Permisos.",
    "mic_denied_web": "No se pudo acceder al micrófono. Concede permiso desde el navegador.",
    "no_audio": "No estamos recibiendo audio. La grabación puede haber fallado.",
    "paused_long": "Estuviste pausado más de 5 minutos. ¿Seguro que quieres continuar la grabación?",
    "save_failed": "No pudimos guardar la grabación. Por favor reintenta.",
    "mode_record": "Grabar",
    "mode_upload": "Subir archivo",
    "drop_audio_here": "Arrastra tu archivo de audio aquí",
    "drop_audio_hint": "o haz clic para elegir · .mp3, .m4a, .wav, .ogg, .webm, .mp4, .flac (máx 200 MB)",
    "audio_click_change": "Clic para cambiar",
    "audio_duration": "Duración: {time}",
    "audio_bad_format": "Formato no soportado. Acepta {formats}.",
    "audio_too_big": "Archivo muy grande (máx 200 MB).",
    "audio_no_duration": "No se pudo leer la duración del audio. Prueba con otro formato (mp3, m4a o wav).",
    "audio_too_long": "Este audio dura {real} min y tu plan permite hasta {max} min por reunión.",
    "audio_exceeds_quota": "Este audio dura {real} min pero solo te quedan {left} min este mes.",
    "select_audio_first": "Selecciona un archivo de audio primero.",
    "select_attendee_required": "Selecciona al menos un asistente.",
    "process_audio": "Procesar audio",
    "ai_output_label": "Resultado de la IA",
    "ai_mode_full": "Resumen + tareas",
    "ai_mode_summary": "Solo resumen",
    "ai_instructions_toggle": "Instrucciones para la IA (opcional)",
    "ai_instructions_placeholder": "Ej: enfócate en los acuerdos de presupuesto y sé breve"
  },
  "list": {
    "title": "Reuniones",
    "subtitle": "Graba reuniones y deja que la IA extraiga las tareas accionables.",
    "new_recording": "Nueva grabación",
    "stat_total": "Total",
    "stat_pending": "Pendientes",
    "stat_committed": "Committeadas",
    "stat_quota": "Cuota",
    "loading": "Cargando…",
    "empty_title": "Aún no has grabado reuniones",
    "empty_subtitle": "La IA convierte tus grabaciones en tareas accionables, asignados y un acta ejecutiva — todo automático.",
    "empty_cta": "Graba tu primera reunión",
    "tasks_count": "{n} tareas",
    "review": "Revisar →",
    "view": "Ver",
    "retry": "Reintentar",
    "delete": "Borrar",
    "personal": "Personal",
    "confirm_delete_title": "¿Borrar esta reunión?",
    "confirm_delete_message": "\"{title}\" se eliminará junto con su audio, transcripción y tareas propuestas. Las tareas ya committeadas no se borrarán.",
    "confirm_delete_action": "Borrar",
    "status": {
      "processing": "Procesando",
      "ready": "Pendiente de revisar",
      "committed": "Tareas creadas",
      "failed": "Falló",
      "discarded": "Descartada"
    },
    "groups": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "this_week": "Esta semana",
      "this_month": "Este mes",
      "earlier": "Anteriores"
    },
    "relative": {
      "just_now": "hace un momento",
      "minutes": "hace {n}m",
      "hours": "hace {n}h",
      "days": "hace {n}d"
    },
    "duration_dash": "—"
  },
  "transcripts": {
    "title": "Transcripciones",
    "subtitle": "Importa transcripciones de Meet, Teams, Otter o Fireflies. La IA extrae las tareas accionables.",
    "upload": "Subir transcripción",
    "stat_total": "Total",
    "stat_pending": "Pendientes",
    "stat_committed": "Committeadas",
    "stat_this_month": "Este mes",
    "loading": "Cargando…",
    "empty_title": "Aún no has subido transcripciones",
    "empty_subtitle": "Acepta archivos .txt, .pdf o .docx. La IA detecta tareas, asignados y fechas automáticamente.",
    "empty_cta": "Subir mi primera transcripción",
    "review": "Revisar",
    "view": "Ver",
    "retry": "Reintentar",
    "delete": "Borrar",
    "personal": "Personal",
    "chars_short": "{n} chars",
    "chars_k": "{n}k chars",
    "confirm_delete_title": "¿Borrar esta transcripción?",
    "confirm_delete_message": "\"{title}\" y sus tareas propuestas se eliminarán. Las tareas ya creadas (committeadas) no se borrarán.",
    "confirm_delete_action": "Borrar"
  },
  "review": {
    "back": "Volver",
    "back_to_meetings": "Volver a reuniones",
    "loading": "Cargando reunión…",
    "processing_title": "Analizando tu reunión…",
    "processing_subtitle_html": "La IA está leyendo la transcripción y extrayendo las tareas accionables. Esto tarda entre <strong>{from} y {to} segundos</strong>. No necesitas recargar — esta página se actualiza sola.",
    "processing_range_from": "5",
    "processing_range_to": "30",
    "failed_title": "No se pudo procesar",
    "retry": "Reintentar",
    "loading_audio": "Cargando audio…",
    "audio_load_failed": "No se pudo cargar el audio.",
    "transcript_full": "Transcripción completa",
    "tasks_proposed": "Tareas propuestas ({selected}/{total})",
    "tasks_created": "Tareas creadas ({n})",
    "add_manual": "Añadir manual",
    "no_tasks_html": "No se detectaron tareas accionables.<br>Puedes añadir una manual.",
    "summary_title": "Acta ejecutiva",
    "summary_save": "Guardar",
    "summary_edit": "Editar",
    "summary_empty": "Sin acta. Click en \"Editar\" para añadir notas.",
    "summary_placeholder": "## Temas tratados\n- ...",
    "discard_all": "Descartar todo",
    "tasks_selected_one": "{selected} de {total} tarea seleccionada",
    "tasks_selected_other": "{selected} de {total} tareas seleccionadas",
    "creating": "Creando…",
    "create_n_tasks_one": "Crear {n} tarea",
    "create_n_tasks_other": "Crear {n} tareas",
    "committed_badge": "Tareas creadas",
    "committed_badge_archived": " · archivada",
    "pdf_generating_title": "Generando PDF…",
    "pdf_download_title": "Descargar acta en PDF",
    "pdf_generating": "Generando…",
    "pdf_short": "PDF",
    "confirm_discard_title": "¿Descartar la reunión?",
    "confirm_discard_message": "Se eliminará la reunión y todas las tareas propuestas que aún no committeas. Esta acción no se puede deshacer.",
    "confirm_discard_action": "Descartar",
    "select_at_least_one": "Selecciona al menos una tarea con título.",
    "pdf_failed": "No se pudo generar el PDF. Intenta de nuevo.",
    "refresh_failed_console": "No se pudo refrescar la reunión",
    "retry_failed_console": "No se pudo reintentar",
    "audio_failed_console": "No se pudo cargar el audio",
    "save_summary_only": "Guardar acta",
    "summary_only_badge": "Solo resumen"
  }
}
